import React, { Component } from 'react';
import Pic from './Pic';

export default class SlideShow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            len: (this.props.imgs.length - 1),
            j: (this.props.initJ > (this.props.imgs.length - 2) ? 0 : this.props.initJ),
            pics: [],
            firstTime: true,
        }
    }

    componentDidMount() {
        this.buildHierarchy();
        if (this.state.j >= this.state.len) this.setState({j: 0});
        this.buildHierarchy();

        this.interval = setInterval(() => {
            this.state.j >= this.state.len ? (
                this.setState({j: 0})
            ) : (
                this.setState({j: this.state.j + 1})
            );

            this.buildHierarchy();
        }, 8000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    buildHierarchy() {
        let a = [];
        let j = this.state.j;

        a.push(this.props.imgs[j === 0 ? this.state.len : (j - 1)]);
        a.push(this.props.imgs[j]);
        this.setState({pics: a});

        const img = new Image();
        img.src = this.props.imgs[j === this.state.len ? 0 : (j + 1)];

        setTimeout(() => {
            a.push(this.props.imgs[j === this.state.len ? 0 : (j + 1)]);
            this.setState({pics: a, firstTime: false});
        }, 5500);
    };

    render() {
        return (
            <div id="slideShowParent">
                {this.state.pics.map((o, i) => {
                    return <Pic order={(this.state.j + i) % 4} lifeCycle={i} src={o} key={o} firstTime={this.state.firstTime} />;
                })}
                {this.state.pics.map((o, i) => {
                    return <span>{o}</span>;
                })}
            </div>
        );
    }
}
